import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-address_choice",
  "use": "icon-address_choice-usage",
  "viewBox": "0 0 32 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 22\" id=\"icon-address_choice\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M-6-11h44v44H-6z\" /><path fill=\"#0078FF\" d=\"M12.333 16.815 29.185-.039l2.595 2.593L12.332 22 .666 10.333 3.258 7.74z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol